<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <tenant-code />
      </b-col>
      <b-col cols="12">
        <title-name />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <phone-number />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <phone-number-2 />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <email-address />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <tax-no />
      </b-col>
      <b-col
        cols="12"
        md="8"
      >
        <tax-office />
      </b-col>
      <b-col cols="12">
        <address-text />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <city-select />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <district-select />
      </b-col>
      <b-col cols="12">
        <notes-text />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import TenantCode from '@/views/Admin/Tenants/elements/TenantCode.vue'
import TitleName from '@/views/Admin/Tenants/elements/Title.vue'
import PhoneNumber from '@/views/Admin/Tenants/elements/PhoneNumber.vue'
import PhoneNumber2 from '@/views/Admin/Tenants/elements/PhoneNumber2.vue'
import EmailAddress from '@/views/Admin/Tenants/elements/EmailAddress.vue'
import TaxNo from '@/views/Admin/Tenants/elements/TaxNo.vue'
import TaxOffice from '@/views/Admin/Tenants/elements/TaxOffice.vue'
import AddressText from '@/views/Admin/Tenants/elements/Address.vue'
import CitySelect from '@/views/Admin/Tenants/elements/City.vue'
import DistrictSelect from '@/views/Admin/Tenants/elements/District.vue'
import NotesText from '@/views/Admin/Tenants/elements/Notes.vue'

export default {
  name: 'ItemForm',
  components: {
    BRow,
    BCol,
    BCard,
    TenantCode,
    TitleName,
    AddressText,
    CitySelect,
    DistrictSelect,
    NotesText,
    PhoneNumber,
    PhoneNumber2,
    EmailAddress,
    TaxNo,
    TaxOffice,
  },
}
</script>
